export default "__VITE_ASSET__DlTMaBO3__"